module.exports = __webpack_public_path__ + "img/clique-aqui.a07edb90.jpg";